import { Label } from 'types/Label'
import * as Styled from './LabelsList.styles'

interface LabelsListProps {
  labels: Label[]
  onDelete: (id: number) => void
  onEdit: (label: Label) => void
  className?: string
  companyLabels?: boolean
}

const LabelsList: React.FC<LabelsListProps> = ({
  labels,
  onEdit: handleEdit,
  onDelete: handleDelete,
  className,
}) => (
  <Styled.RootContainer className={className}>
    {labels.map((label) => (
      <Styled.LabelsListItem
        key={label.id}
        label={label}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
    ))}
  </Styled.RootContainer>
)

export { LabelsList }
